import { TNotification } from '../../../redux/types';

export const getNoReadNotifications = (
  notifications?: TNotification[]
): boolean => {
  return !!notifications?.filter((notification) => !notification.isRead)
    ?.length;
};
